<template>
    <div class="bg-white">
    
        <!-- <CCol sm="12" lg="8" class="mx-auto" style="width: 70%; background-size: cover; color: #fff;">
                    <div>
                        <CRow>
                            <CCol sm="8" style="margin:0 auto">
                                <div style="margin-top: 15%;">
                                    <CCard class="b-20">
                                        <h3 class="text-center text-black mt-5">Welcome Back</h3>
            
                                        <CCol sm="12" style="width: 70%; background-size: cover; margin: auto; color: #fff;">
                                            <CRow class="mt-5">
                                                <div v-if="this.Error == true" class="ml-1 mr-1 mt-2 mb-2">
                                                    <CAlert show color="danger" class="custom-error-message">The credentials entered is incorrect.Please try again.</CAlert>
                                                </div>
                                                <CCol sm="12">
                                                    <h3 class="custom-14px">Email Address</h3>
                                                    <CInput type="text" class="custom-input b-50" v-model="Email" />
                                                </CCol>
                                                <CCol sm="12">
                                                    <h3 class="custom-14px">Password</h3>
                                                    <CInput type="password" class="custom-input b-50" v-model="Password" />
                                                </CCol>
                                                <CCol sm="12">
                                                    <div class="text-right">
                                                        <label class="custom-16px-600">
                                                                I forgot my password
                                                            </label>
                                                    </div>
                                                </CCol>
                                                <CButton type="button" class="bg-button-blue text-white m-2" block v-on:click="trylogin">Login</CButton>
                                            </CRow>
                                            <CRow>
                                                <img src="../assets/img/loginwith.png" style="max-width:100%" />
                                                <div style="width:50%">
                                                    <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px" @click="login">
                                                        <img style="width:25px" src="../assets/img/google1.png" class="mt-1 mb-1 mr-2" />
                                                    </div>
                                                </div>
                                                <div style="width:50%">
                                                    <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px">
                                                        <img style="width:25px" src="../assets/img/apple1.png" class="mt-1 mb-1 ml-2" />
                                                    </div>
                                                </div>
            
                                            </CRow>
                                            <div class="text-center mt-3">
                                                <label class="custom-14px poppin-font"> Don’t have an account? <a href="CreateAccount">Create Now</a></label>
                                            </div>
                                        </CCol>
            
                                        <div class="mt-4">
                                            <div class="inline-container">
            
                                                <span class="text-center text-black" style="margin-left:40%">{{ lblGoogle }}</span>
            
                                            </div>
                                        </div>
            
            
                                    </CCard>
                                    <br /><br />
                                </div>
                            </CCol>
                        </CRow>
                    </div>
                </CCol> -->
    
        <div>
            <CRow class="g-3">
                <CCol sm="6" lg="6">
                    <div class="p-2">
                        <div style="background-position: center;background-size: cover; min-height: 100vh;border-radius:18px" :style="{ backgroundImage: `url(${backgroundUrl})` }"></div>
                    </div>
                </CCol>
    
                <CCol sm="6">
                    <CRow class="p-2">
                        <CCol sm="8"></CCol>
                        <CCol sm="4">
                            <img src="../assets/img/Logo.png" height="32" alt="Interviewrr.ai company logo" class="mt-2" /> <span class="custom-20px-500 text-white"></span>
                        </CCol>
    
                    </CRow>
    
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div style="margin-top:20%">
                            <h3 class="custom-24px-600 font-color-171717 text-left">Reset your password</h3>
                            <p class="custom-18px-500"><span class="font-color-666D80">Enter your email address and we’ll send you password reset instructions.</span></p>
                        </div>
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
                       

                        <CCol md="12" class="text-center mt-3 d-none d-sm-block" style="width: 100%; background-size: cover; margin: auto;">
                                           
                                           <div class="verification-input">
                                               <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code m-2"/> 
                                               <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code m-2"/>
                                               <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code m-2"/>
                                               <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code m-2" />
                                           </div>
                                       </CCol>
                                       <!-- Column for mobile view -->
                                       <CCol xs="12" class="text-center mt-3 d-sm-none" style="width: 100%; background-size: cover; margin: auto;">
                                        
                                           <div class="verification-input">
                                               <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                               <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                               <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                               <input v-model="code[3]" maxlength="1" style="width:20%" class="custom-code" />
                                           </div>
                                       </CCol>
                                       <div style="clear:both"></div>
    
                        <div class="text-center mt-4 mb-2">
                            <CButton class="button-Explore text-white custom-border-radius-12px" v-on:click="" block size="lg">Verify</CButton>
                        </div>
    
    
    
    
    
                    </CContainer>
                </CCol>
    
    
            </CRow>
    
        </div>
    
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgloginsport3.png";
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '435242184873-lfkbjg7vnqp31opg3qgnn1u0pf0ve5kt.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl: backgroundUrl,
            code: ""

        };
    },
    created() {
        AOS.init();
    },
    methods: {
        GoToSignUp() {
            this.$router.push("CreateAccount");
        },
        submitVerification() {
            this.verificationCode = this.code.join(""); // Concatenate the digits
            console.log("Verification Code:", this.verificationCode);
            this.ValidateCode(this.verificationCode);
        },
        ValidateCode(verificationCode) {
this.lblProcess = true;
            const formData = new FormData();

            formData.append("userEmail", this.$route.query.email);
            formData.append("code", verificationCode);

            return this.$API
                .post(this.$ValidateForgotPasswordCode, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {
                       
                       this.$router.push("ResetPassword?email="+ this.$route.query.email + "&code=" + verificationCode);
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },

    }

};
</script>

<style scoped>

</style>